"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M9 18h12v-2H9zM3 6v2h18V6zm6 7h12v-2H9z"
}), 'SegmentTwoTone');